module.exports = __webpack_public_path__ + "img/pack2.253172cd.png";